import React from 'react';
import moment from 'moment';
import styles from './CommissioningInfo.module.css';
import { GET_LAST_COMMISSION_DATE_STATUS } from 'pages/PivotOverviewPage/utils';

const getLastCommissionDateDisplay = (dateTime) => {
  if (!dateTime) return 'Unknown';
  if ([GET_LAST_COMMISSION_DATE_STATUS.PENDING, GET_LAST_COMMISSION_DATE_STATUS.NOT_FOUND].includes(dateTime))
    return 'Unknown';

  return moment(dateTime).format('MMM D, YYYY');
};

const CommissioningInfo = ({ lastCommissionDate }) => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>Last commission date</div>
        <div className={styles.body}>{getLastCommissionDateDisplay(lastCommissionDate)}</div>
      </div>
    </div>
  );
};

export default CommissioningInfo;
